import { videosOnEnterSaga, liveAdminOnEnterSaga, liveOnEnterSaga } from 'features/Videos/sagas/live.onenter.saga';
import { CP_LIVE_PARTNER_ALIAS } from 'constants/video'; // polyfill webpack require.ensure

if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export var VideosRoute = function VideosRoute(store, client) {
  return {
    path: '/videos',
    onEnter: function onEnter(nextState, replaceState, cb) {
      return store.runSagaOnce(videosOnEnterSaga, client, nextState, replaceState, '/').done.then(cb);
    },
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        return callback(null, {
          component: require('./VideosContainer').VideosContainer,
          onEnter: function onEnter(nextState, replaceState, cb) {
            return store.runSagaOnce(liveOnEnterSaga, client, nextState, replaceState, 'videos/partners').done.then(cb);
          }
        });
      }, 'videos');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          path: 'upcoming',
          component: require('./UpcomingLiveContainer').UpcomingLiveContainer,
          onEnter: function onEnter(nextState, replaceState, cb) {
            return store.runSagaOnce(liveOnEnterSaga, client, nextState, replaceState).done.then(cb);
          }
        }, {
          path: 'on-demand',
          component: require('./OnDemandContainer').OnDemandContainer,
          onEnter: function onEnter(nextState, replaceState, cb) {
            return store.runSagaOnce(liveOnEnterSaga, client, nextState, replaceState).done.then(cb);
          }
        }, {
          path: 'partners',
          component: require('./PartnerVideosContainer').PartnerVideosContainer
        }, {
          path: 'live',
          component: require('./VideosContainer').VideosContainer,
          onEnter: function onEnter(nextState, replaceState, cb) {
            return store.runSagaOnce(liveOnEnterSaga, client, nextState, replaceState).done.then(cb);
          }
        }, {
          path: 'live/:liveAlias',
          component: require('features/VideoDetail/VideoDetailContainer').VideoDetailContainer,
          onEnter: function onEnter(nextState, replaceState, cb) {
            return store.runSagaOnce(liveOnEnterSaga, client, nextState, replaceState).done.then(cb);
          }
        }, {
          path: 'live-admin/:adminAlias',
          component: require('features/VideoDetail/VideoDetailContainer').VideoDetailContainer,
          onEnter: function onEnter(nextState, replaceState, cb) {
            return store.runSagaOnce(liveAdminOnEnterSaga, client, nextState, replaceState).done.then(cb);
          }
        }, {
          path: "".concat(CP_LIVE_PARTNER_ALIAS, "/:ghostAlias"),
          component: require('features/VideoDetail/VideoDetailContainer').VideoDetailContainer,
          onEnter: function onEnter(nextState, replaceState, cb) {
            return store.runSagaOnce(liveOnEnterSaga, client, nextState, replaceState).done.then(cb);
          }
        }, {
          path: 'collection/:collectionId*',
          component: require('./CollectionContainer').CollectionContainer
        }, {
          path: ':partnerAlias/:videoAlias',
          component: require('features/VideoDetail/VideoDetailContainer').VideoDetailContainer
        }]);
      }, 'videos');
    }
  };
};